import { apiClient } from '../httpClient';
import { handleApiError } from '../utils/errorHandler';

export const bundleService = {
  /**
   * Bundle latest 메타 (signed URL + version)
   * GET /java/bundle/v1/latest
   */
  getLatestMeta: async () => {
    try {
      const response = await apiClient.get('/java/bundle/v1/latest');
      return { success: true, data: response.data };
    } catch (error) {
      return handleApiError(error, 'Bundle 메타를 가져오는데 실패했습니다.');
    }
  },
};
